<template>
    <form-wrapper method="GET" action="" @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.signup.fields.first_name.label')"
                    :placeholder="$t('forms.auth.signup.fields.first_name.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="firstName"
                    valuePath="firstName"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.signup.fields.last_name.label')"
                    :placeholder="$t('forms.auth.signup.fields.last_name.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="lastName"
                    valuePath="lastName"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.signup.fields.email.label')"
                    :placeholder="$t('forms.auth.signup.fields.email.placeholder')"
                    :isRequired="true"
                    :isDisabled="!!invitationToken"
                    type="email"
                    name="email"
                    valuePath="email"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.signup.fields.password.label')"
                    :placeholder="$t('forms.auth.signup.fields.password.placeholder')"
                    :isRequired="true"
                    type="password"
                    name="password"
                    valuePath="password"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.signup.fields.password_repeat.label')"
                    :placeholder="$t('forms.auth.signup.fields.password_repeat.placeholder')"
                    :isRequired="true"
                    type="password"
                    valuePath="passwordRepeat"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <div class="agrement">
                <checkbox-input
                    type="checkbox"
                    labelPosition="left"
                    :value="isAgrementAccept"
                    @change="isAgrementAccept = !isAgrementAccept"
                ></checkbox-input>
                <div class="agrement--links">
                    {{ $t('forms.auth.signup.agrement') }}
                    <span class="agrement--links" @click="$router.push({ name: RoutesEnum.AGREMENT.TERMS })">
                        {{ $t('forms.auth.signup.terms') }}&nbsp;
                    </span>
                </div>
            </div>
            <common-buttons>
                <common-button
                    type="primary"
                    :isDisabled="!isAgrementAccept"
                    :isProcessing="isLoading"
                    :label="$t('forms.auth.signup.buttons.signup')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AuthAPI from 'api/AuthAPI'
    import RoutesEnum from 'enums/routes.enum'
    import LoginType from 'enums/login_type.enum'

    export default {
        mixins: [FormMixin],
        props: {
            invitationToken: { type: String, default: undefined },
            finalizeAccountToken: { type: String, default: undefined },
            email: { type: String, default: undefined },
        },
        data() {
            return {
                isAgrementAccept: false,
                RoutesEnum,
            }
        },
        methods: {
            submit() {
                if (this.data.password !== this.data.passwordRepeat) {
                    this.setErrors([
                        { path: 'password', value: this.$t('forms.auth.signup.passwords_not_match') },
                        { path: 'passwordRepeat', value: this.$t('forms.auth.signup.passwords_not_match') },
                    ])
                    return
                }
                if (this.finalizeAccountToken) {
                    const request = {
                        email: this.data.email,
                        firstName: this.data.firstName,
                        lastName: this.data.lastName,
                        password: this.data.password,
                        finalizeAccountToken: this.finalizeAccountToken,
                    }
                    AuthAPI.finalizeAccount(request)
                        .then((response) => {
                            if (response && response.payload && response.payload.access_token) {
                                this.$auth.createSession({
                                    accessToken: response.payload.access_token,
                                    refreshToken: response.payload.refresh_token,
                                    loginType: LoginType.BASIC,
                                })
                                this.$router.push({
                                    name: RoutesEnum.SUBDOMAIN.COMPANY,
                                    query: { finalize: 'success' },
                                })
                            } else {
                                this.$router.push({
                                    name: RoutesEnum.AUTH.LOGIN,
                                    query: {
                                        text: this.$t(`pages.auth.signup.messages.register_success`),
                                        type: 'success',
                                        fromSignUp: 1,
                                    },
                                })
                            }
                        })
                        .catch((error) => {
                            if (error.statusCode === 400) {
                                this.$toast.error(
                                    this.$t(`forms.auth.signup.errors.${error.error.message.replace('.', '_').toLowerCase()}`),
                                )
                            }
                        })
                } else {
                    this.submitForm(
                        AuthAPI.register({
                            email: this.data.email,
                            firstName: this.data.firstName,
                            lastName: this.data.lastName,
                            password: this.data.password,
                            language: this.$i18n.locale,
                            invitationToken: this.invitationToken,
                        }).then(() => {
                            this.$router.push({
                                name: RoutesEnum.AUTH.LOGIN,
                                query: {
                                    text: this.$t(
                                        `pages.auth.signup.messages.${this.invitationToken ? 'invite' : 'register'}_success`,
                                    ),
                                    type: 'success',
                                    fromSignUp: 1,
                                },
                            })
                        }),
                    ).catch((error) => {
                        if (error.statusCode === 400) {
                            this.$toast.error(
                                this.$t(`forms.auth.signup.errors.${error.error.message.replace('.', '_').toLowerCase()}`),
                            )
                        }
                    })
                }
            },
            prefillInvitation() {
                if (this.email) {
                    const data = { email: this.email }
                    this.prefillData(data)
                }
            },
        },
        watch: {
            email() {
                this.prefillInvitation()
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/variables';
    .agrement {
        display: flex;
        margin-bottom: 20px;

        &--links {
            color: $color-link;
            cursor: pointer;
            max-width: 400px;
        }

        .checkbox-input {
            margin-right: 10px;
        }
    }

    .form__footer {
        flex-wrap: wrap;
    }
</style>
